import React from "react";
import { Skeleton } from "@mantine/core";

export default function CustomSkeletonTable({ columns = [], rowCount = 8 }) {
  return (
    <div className="flex flex-col">
      <div className="rounded bg-white-50">
        <table className="min-w-full divide-y divide-neutral-800">
          <thead className="bg-neutral-900">
            <tr>
              {columns.map((col, index) => (
                <th
                  key={index}
                  className="px-4 py-2 text-left text-xs font-semibold text-neutral-300"
                >
                  <Skeleton height={12} width="70%" radius="sm" />
                </th>
              ))}
            </tr>
          </thead>

          <tbody className="divide-y divide-neutral-800">
            {Array.from({ length: rowCount }).map((_, idx) => (
              <tr key={idx} className="bg-white-50 h-[50px]">
                {columns.map((col, colIdx) => (
                  <td
                    key={colIdx}
                    className="px-4 py-2 text-sm text-neutral-50"
                  >
                    <Skeleton height={16} radius="sm" />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
